module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#user",
      toString: function () {
        return this.url;
      }
    }